import React from 'react';
import { useTranslation } from 'react-i18next';

const Contact: React.FC = () => {
  // @ts-ignore
  const { t } = useTranslation();

  return (
    <div className="page-container">
      {/* @ts-ignore */}
      <h1 className="page-title">{t('contact.title')}</h1>
      <div className="contact-simple">
        <div className="contact-card">
          <div className="contact-info">
            <div className="info-item">
              <div className="info-icon">📍</div>
              {/* @ts-ignore */}
              <p>{t('contact.address')}</p>
            </div>
            <div className="info-item">
              <div className="info-icon">📧</div>
              <p>info@matrixcube.sg</p>
            </div>
            
            <div className="contact-action">
              <a href="mailto:info@matrixcube.sg" className="email-button">
                {/* @ts-ignore */}
                {t('contact.submit')}
              </a>
            </div>
          </div>
        </div>
        
        <div className="map-container">
          <iframe 
            title="Matrix Cube Office Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.822506808799!2d103.78468807574049!3d1.2924926987074394!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1bb0b4d5b5a7%3A0x3bfae8b5c6c7a7e7!2sAlexandra%20Technopark%2C%20438B%20Alexandra%20Rd%2C%20Singapore%20119968!5e0!3m2!1sen!2ssg!4v1737828888000!5m2!1sen!2ssg" 
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen={true} 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact; 